import React from 'react';
import css from './HeroSection.module.css';
import heroBgMobile from '../../../../assets/Customer-Landingpage-hero-sectionhalf.png';
import heroBgDesktop from '../../../../assets/Customer-Landingpage-hero-section.png';
import planningPortalIcon from '../../../../assets/PlanningPortalSVG.svg';

const TRUST_BADGES = [
  { icon: '✔', text: 'Matched with relevant suppliers' },
  { icon: '✔', text: 'Takes less than 60 seconds' },
  { icon: '✔', text: 'Get clarity on your build costs' },
];

const HeroSection = ({ ppRef, onPpRefChange, onStartProject, onContinueAnyway }) => {
  return (
    <section className={css.hero}>
      <picture>
        <source media="(max-width: 768px)" srcSet={heroBgMobile} />
        <img src={heroBgDesktop} alt="" className={css.bgImage} aria-hidden="true" />
      </picture>
      <div className={css.overlay} />

      <div className={css.content}>
        <div className={css.navSpacer} />
        {/* Planning Portal badge */}
        <div className={css.partnerBadge}>
          <span className={css.partnerText}>In collaboration with</span>
          <img src={planningPortalIcon} alt="Planning Portal" className={css.partnerIcon} />
          <span className={css.partnerName}>
            <strong>Planning</strong>Portal
          </span>
        </div>

        {/* Heading */}
        <h1 className={css.heading}>
          Just submitted your <em className={css.highlight}>planning?</em>
          <br />
          <em className={css.highlight}>Start preparing</em> your build now
        </h1>

        {/* Subtext */}
        <p className={css.subtext}>
          See your build cost using your planning data, then match with<br />builders when you're ready.
        </p>

        {/* Input + CTA */}
        <div className={css.inputRow}>
          <input
            id="ppRefInput"
            className={css.input}
            type="text"
            placeholder="Enter Planning Reference Number"
            aria-label="Planning reference"
            value={ppRef || ''}
            onChange={e => onPpRefChange && onPpRefChange(e.target.value)}
          />
          <button type="button" className={css.ctaBtn} onClick={() => onStartProject && onStartProject(ppRef)}>
            Start My Project
          </button>
        </div>

        {/* Continue anyway */}
        <p className={css.continueText}>
          Don't have a planning reference or not submitted yet?{' '}
          <button
            type="button"
            className={css.continueLink}
            onClick={onContinueAnyway}
          >
            Continue anyway →
          </button>
        </p>

      </div>

      {/* Trust badges — pinned to bottom of hero */}
      <div className={css.trustBar}>
        {TRUST_BADGES.map(badge => (
          <div key={badge.text} className={css.trustBadge}>
            <span className={css.trustIcon}>{badge.icon}</span>
            <span>{badge.text}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HeroSection;
